<div matTooltip="Residual Value: {{value}}">
  <div *ngIf="exists" style="background-color:rgb(64, 192, 64); height: 24px; width: 12px">&nbsp;</div>
  <div *ngIf="!exists" style="background-color: rgb(159, 223, 159) ; height: 24px; width: 12px">&nbsp;</div>
</div>
